import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../../../common/utils/HeaderUtils';

/**
 * Custom hook to call source registry name validation api
 * @returns promise
 */
const useSourceNameValidation = () => {
  async function callGetSourceDetailsApi(sourceName: string) {
    const { responseBody, isError, error } = await apiWrapper.post(
      `${process.env.REACT_APP_API_CONTROL_PLANE_SOURCE_REGISTRY_URL}/sources/search`,
      {
        sources: [{ sourceName }],
        status: [
          'ACTIVE'
        ],
        exactNameMatch: true
      },
      headersInstance()
    );

    if (isError) {
      throw error;
    }

    return { data: responseBody as { sources: any } };
  }

  const fetchSourceNameDetails = (sourceName: string) => callGetSourceDetailsApi(sourceName);

  return { fetchSourceNameDetails };
};

export default useSourceNameValidation;
